/* eslint-disable prefer-destructuring */
const BRANCH = process.env.BRANCH
const GATSBY_CONTROL_GROUP = process.env.GATSBY_CONTROL_GROUP

const ABTestGroup = {
  current: () => (GATSBY_CONTROL_GROUP && BRANCH === 'master' ? GATSBY_CONTROL_GROUP : BRANCH),
}

export default ABTestGroup
